// Phase 2/3 — Flotte : Véhicules, Maintenance, Carburant
import React from "react";
import GenericModule from "@/components/GenericModule";

export function Vehicles() {
  return (
    <GenericModule
      title="Parc automobile"
      subtitle="Véhicules du groupe"
      dataTestId="vehicles"
      endpoint="/vehicles"
      newButtonLabel="Nouveau véhicule"
      extractStats={(d) => [
        { label: "Véhicules", value: d.total || 0, count: true },
        { label: "Échéances à venir", value: (d.expiring_soon || []).length, count: true, accent: "warn" },
      ]}
      columns={[
        { key: "plate", label: "Immatriculation", type: "code" },
        { key: "brand", label: "Marque" },
        { key: "model", label: "Modèle" },
        { key: "year", label: "Année", type: "number" },
        { key: "fuel_type", label: "Carburant" },
        { key: "odometer", label: "Km", type: "number", align: "right" },
        { key: "driver", label: "Chauffeur" },
        { key: "insurance_expiry", label: "Assurance", type: "date" },
        {
          key: "status", label: "Statut", type: "pill",
          pillClass: (r) => ({ actif: "bg-ok/15 text-ok", maintenance: "bg-warn/15 text-warn", hors_service: "bg-bad/15 text-bad" })[r.status],
        },
      ]}
      fields={[
        { key: "plate", label: "Immatriculation", required: true, group: 1 },
        { key: "brand", label: "Marque", group: 1 },
        { key: "model", label: "Modèle", group: 2 },
        { key: "year", label: "Année", type: "number", group: 2 },
        { key: "fuel_type", label: "Carburant", type: "select", options: ["Essence", "Gasoil", "Hybride"], group: 3 },
        { key: "odometer", label: "Km", type: "number", group: 3 },
        { key: "status", label: "Statut", type: "select", options: ["actif", "maintenance", "hors_service"], group: 3 },
        { key: "driver", label: "Chauffeur" },
        { key: "insurance_expiry", label: "Échéance assurance", type: "date", group: 4 },
        { key: "technical_expiry", label: "Échéance technique", type: "date", group: 4 },
        { key: "notes", label: "Notes", type: "textarea" },
      ]}
      defaults={{ plate: "", brand: "", model: "", year: 2024, fuel_type: "Gasoil", odometer: 0, driver: "", status: "actif", insurance_expiry: "", technical_expiry: "", notes: "" }}
    />
  );
}

export function Maintenance() {
  return (
    <GenericModule
      title="Maintenance"
      subtitle="Interventions techniques"
      dataTestId="maintenance"
      endpoint="/maintenance"
      newButtonLabel="Nouvelle intervention"
      extractStats={(d) => [{ label: "Coût total", value: d.total_cost || 0, money: true, accent: "warn", highlight: true }]}
      columns={[
        { key: "date", label: "Date", type: "date" },
        { key: "vehicle_id", label: "Véhicule", type: "code" },
        { key: "type", label: "Type" },
        { key: "description", label: "Description" },
        { key: "garage", label: "Garage / Prestataire" },
        { key: "cost", label: "Coût", type: "money", align: "right" },
      ]}
      fields={[
        { key: "vehicle_id", label: "ID Véhicule (ou immat.)", required: true, group: 1 },
        { key: "date", label: "Date", type: "date", required: true, group: 1 },
        { key: "type", label: "Type", type: "select", options: ["Vidange", "Pneus", "Révision", "Réparation", "Contrôle technique", "Assurance", "Autre"], required: true, group: 2 },
        { key: "cost", label: "Coût (XAF)", type: "number", required: true, group: 2 },
        { key: "description", label: "Description", type: "textarea" },
        { key: "garage", label: "Garage / Prestataire" },
      ]}
      defaults={{ vehicle_id: "", date: new Date().toISOString().slice(0, 10), type: "Vidange", cost: 0, description: "", garage: "" }}
    />
  );
}

export function FuelStock() {
  return (
    <GenericModule
      title="Stock carburant"
      subtitle="Stations ROPS"
      dataTestId="fuel-stock"
      endpoint="/fuel-stock"
      newButtonLabel="Nouvelle cuve"
      extractStats={(d) => [
        { label: "Litres totaux", value: d.total_liters || 0, count: true, accent: "citron", highlight: true },
        { label: "Cuves basses", value: (d.low_stock || []).length, count: true, accent: "warn" },
      ]}
      columns={[
        { key: "station", label: "Station" },
        { key: "product", label: "Produit", type: "pill" },
        { key: "quantity_liters", label: "Litres", type: "number", align: "right", digits: 1 },
        { key: "buy_price_per_liter", label: "PA/L", type: "money", align: "right" },
        { key: "sell_price_per_liter", label: "PV/L", type: "money", align: "right" },
        { key: "alert_level", label: "Alerte (L)", type: "number", align: "right" },
      ]}
      fields={[
        { key: "station", label: "Station", required: true, placeholder: "ROPS Glass, ROPS Owendo…", group: 1 },
        { key: "product", label: "Produit", type: "select", options: ["Super", "Gasoil", "Pétrole"], required: true, group: 1 },
        { key: "quantity_liters", label: "Litres en cuve", type: "number", required: true, group: 2 },
        { key: "alert_level", label: "Niveau d'alerte (L)", type: "number", group: 2 },
        { key: "buy_price_per_liter", label: "Prix achat / L", type: "number", group: 3 },
        { key: "sell_price_per_liter", label: "Prix vente / L", type: "number", group: 3 },
      ]}
      defaults={{ station: "", product: "Gasoil", quantity_liters: 0, alert_level: 1000, buy_price_per_liter: 0, sell_price_per_liter: 0 }}
    />
  );
}
